import {
    Message
} from "element-ui";
import {
    download,
    downloadFtpFile
} from "../../api/common";
import fetchFile from "../../utils/downloadUtils"

export const exportFile = {
    data() {
        return {
            selectFormat: []
        }
    },
    methods: {
        handleExportFile(selectFormat, threeDimensions) {
            const self = this;
            self.exportDialogVisible = false;
            self.downloadFile({
                type: selectFormat,
                count: self.pageSize,
                threeDimensions: threeDimensions
            });
        },
        downloadFile(data) {
            const self = this;
            self.exportDialogLoading = true;
            let excelType = "";
            let fileName = "";
            if (data.type === "xlsx") {
                excelType = "application/x-xls;charset=utf-8";
                fileName = "最新评价.xlsx";
            }
            if (data.type === "csv") {
                excelType = "text/csv;charset=utf-8";
                fileName = "最新评价.csv";
            }
            if (data.type === "pdf" || data.type === "ftpFile") {
                excelType = "application/pdf;charset=utf-8";
                fileName = "最新评价.pdf";
            }
            let func;
            if (data.type == "ftpFile") {
                func = downloadFtpFile;
                fileName = data.fileName + ".pdf";
            } else {
                func = download;
            }

            let timer = -1;
            let msgObj = null;
            if (this.$message != null) {
                msgObj = this.$message({
                    message: "后台数据准备中",
                    showClose: true,
                    center: true,
                    duration: 0
                });
                let count = 1;
                let stFix = ['......', '.', '..', '...', '....', '.....'];
                timer = setInterval(() => {
                    let idx = count % 6;
                    count++;
                    if (msgObj) {
                        msgObj.message = "后台数据准备中" + stFix[idx];
                    }
                }, 500);
            }
            
            func(data)
                .then(response => {
                    let data = response.data;
                    if (timer != -1) {
                        clearInterval(timer);
                    }
                    
                    Message.closeAll();

                    if (response.status == 200) {
                        fetchFile(data, excelType, fileName);
                        Message({
                            message: "文件名：" + fileName + ",下载成功！",
                            type: "success",
                            showClose: true,
                            center: true,
                            duration: 5 * 1000
                        });
                        Message.close = function() {};
                    }
                })
                .catch(err => {
                    if (timer !== -1) {
                        clearInterval(timer);
                    }
                    if (msgObj) {
                        msgObj.close();
                    }
                    Message.closeAll();

                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        showClose: true,
                        center: true,
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.exportDialogLoading = false;
                });
        },
    }
} 

export default exportFile;